import BreadCrump from "../tools/breadcrump";
import { getCookies } from "cookies-next";
import { useEffect, useState } from "react";
import axios from "axios";
import Swal from 'sweetalert2';
import { config } from "../../data/config";
import HeaderOfPage from "../tools/headerOfPage";
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";

const LANGUAGE_KEYS: Record<string, string> = {
    english: 'English',
    persian: 'Persian',
    arabic: 'Arabic',
    chinese: 'Chinese',
    russian: 'Russian',
    spanish: 'Spanish',
    japanese: 'Japanese',
    turkish: 'Turkish',
    kurdish: 'Kurdish',
    french: 'French',
    german: 'German',
    italian: 'Italian',
    portuguese: 'Portuguese',
};

export default function ListAgents() {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const cookie = getCookies();
    const [list, setList] = useState<any[]>([]);

    const breadcrump = [
        { name: t('Dashboard'), url: '/dashboard' },
        { name: t('Real Estate System'), url: '/dashboard/RealEstate' },
        { name: t('Agent Management'), url: null },
    ];

    const loaddata = async () => {
        try {
            const res = await axios({
                method: 'get',
                url: `${config.url}/v1/dashboard/realestate/agents`,
                headers: { Authorization: 'Bearer ' + cookie['token'] }
            });
            const data = res.data.message;
            setList(Array.isArray(data) ? data : []);
        } catch (_) {
            setList([]);
        }
    };

    const onDelete = async (id: string) => {
        const result = await Swal.fire({
            title: t("Are you sure?"),
            text: t("Delete this agent?"),
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: t("Yes, delete it!")
        });
        if (result.isConfirmed) {
            try {
                await axios({
                    method: 'delete',
                    url: config.url + '/v1/dashboard/realestate/agents/' + id,
                    headers: { Authorization: 'Bearer ' + cookie['token'] }
                });
                loaddata();
                Swal.fire(t("Deleted"), t("Agent deleted."), "success");
            } catch (_) {
                Swal.fire(t("Error"), t("Could not delete."), "error");
            }
        }
    };

    useEffect(() => {
        loaddata();
    }, []);

    const getLanguagesDisplay = (item: any) => {
        const langs = item?.languages;
        if (!Array.isArray(langs) || langs.length === 0) return '-';
        return langs.map((l: string) => t(LANGUAGE_KEYS[l] || l)).join(', ');
    };

    return (
        <div className="text-left bg-white p-3 m-4 directions h-[100vh] mb-5 ">
            <BreadCrump data={breadcrump} />
            <HeaderOfPage name={t("Agent Management")} />

            <div className="flex flex-wrap gap-2 items-center mb-4">
                <button
                    type="button"
                    onClick={() => navigate('/dashboard/RealEstate/agents/new')}
                    className="py-2.5 px-4 bg-blue-600 text-white rounded-lg hover:bg-blue-700 font-medium"
                >
                    {t("Add Agent")}
                </button>
            </div>

            <div className="overflow-x-auto border border-gray-200 rounded-lg">
                <table className="min-w-full divide-y divide-gray-200">
                    <thead className="bg-gray-50">
                        <tr>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">{t("Name")}</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">{t("Last name")}</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">{t("Phone")}</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">{t("Email")}</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">{t("Languages")}</th>
                            <th className="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase">{t("Active")}</th>
                            <th className="px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase">{t("Actions")}</th>
                        </tr>
                    </thead>
                    <tbody className="bg-white divide-y divide-gray-200">
                        {list.length === 0 ? (
                            <tr>
                                <td colSpan={7} className="px-4 py-8 text-center text-gray-500">
                                    {t("No agents yet.")}
                                </td>
                            </tr>
                        ) : (
                            list.map((item: any) => (
                                <tr key={item._id}>
                                    <td className="px-4 py-3 text-sm text-gray-900">{item.name || '-'}</td>
                                    <td className="px-4 py-3 text-sm text-gray-600">{item.lastname || '-'}</td>
                                    <td className="px-4 py-3 text-sm text-gray-600">{item.phone || '-'}</td>
                                    <td className="px-4 py-3 text-sm text-gray-600">{item.email || '-'}</td>
                                    <td className="px-4 py-3 text-sm text-gray-600">{getLanguagesDisplay(item)}</td>
                                    <td className="px-4 py-3 text-sm">
                                        {item.active !== false ? t("Yes") : t("No")}
                                    </td>
                                    <td className="px-4 py-3 text-right">
                                        <div className="flex items-center justify-end gap-2">
                                            <button
                                                type="button"
                                                onClick={() => navigate(`/dashboard/RealEstate/agents/edit/${item._id}`)}
                                                title={t("Edit")}
                                                className="p-2 rounded-lg text-blue-600 hover:bg-blue-50 transition-colors"
                                            >
                                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                                                </svg>
                                            </button>
                                            <button
                                                type="button"
                                                onClick={() => onDelete(item._id)}
                                                title={t("Delete")}
                                                className="p-2 rounded-lg text-red-600 hover:bg-red-50 transition-colors"
                                            >
                                                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                                                </svg>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            ))
                        )}
                    </tbody>
                </table>
            </div>
        </div>
    );
}
